import { createRouter, createWebHistory } from "vue-router";
import { defineAsyncComponent } from "vue";
import { updateDocumentSeo } from "./seo";

const COMPANY_NAME = "郑州云轩网络科技有限公司";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "Home",
      component: defineAsyncComponent(() => import("@/views/home/index.vue")),
      meta: {
        title: `${COMPANY_NAME}｜软件开发、AI 技术应用与企业数字化服务`,
        description:
          "郑州云轩网络科技有限公司提供软件开发、AI 技术应用、企业管理系统、移动应用及数字化解决方案服务。",
      },
    },
    {
      path: "/about",
      name: "About",
      component: defineAsyncComponent(() => import("@/views/about/index.vue")),
      meta: {
        title: `关于我们｜${COMPANY_NAME}`,
        description:
          "了解郑州云轩网络科技有限公司的企业介绍、组织架构、企业文化与相关资质。",
      },
    },
    {
      path: "/about/business-license",
      name: "BusinessLicense",
      component: defineAsyncComponent(
        () => import("@/views/about/credential.vue")
      ),
      props: { type: "business" },
      meta: {
        title: `营业执照｜${COMPANY_NAME}`,
        description: "查看郑州云轩网络科技有限公司营业执照及企业登记信息。",
      },
    },
    {
      path: "/about/telecom-license",
      name: "TelecomLicense",
      component: defineAsyncComponent(
        () => import("@/views/about/credential.vue")
      ),
      props: { type: "telecom" },
      meta: {
        title: `增值电信业务经营许可证｜${COMPANY_NAME}`,
        description:
          "查看郑州云轩网络科技有限公司增值电信业务经营许可证及获准经营业务信息。",
      },
    },
    {
      path: "/business",
      name: "Business",
      component: defineAsyncComponent(
        () => import("@/views/business/index.vue")
      ),
      meta: {
        title: `业务范围｜软件开发与企业数字化服务｜${COMPANY_NAME}`,
        description:
          "提供定制软件开发、企业管理系统、移动应用、AI 技术应用、网络推广与数字化解决方案。",
      },
    },
    {
      path: "/success-cases",
      name: "SuccessCases",
      component: defineAsyncComponent(
        () => import("@/views/success-cases/index.vue")
      ),
      meta: {
        title: `成功案例｜企业软件与数字化项目｜${COMPANY_NAME}`,
        description:
          "查看郑州云轩网络科技有限公司在物流、电商、制造、教育、商业、酒店、园区和医疗等领域的项目案例。",
      },
    },
    {
      path: "/success-cases/:id",
      name: "SuccessCaseDetail",
      component: defineAsyncComponent(
        () => import("@/views/success-cases/detail.vue")
      ),
    },
    {
      path: "/partners",
      name: "Partners",
      component: defineAsyncComponent(
        () => import("@/views/partners/index.vue")
      ),
      meta: {
        title: `合作伙伴｜${COMPANY_NAME}`,
        description:
          "了解郑州云轩网络科技有限公司的合作方向与企业数字化服务合作伙伴。",
      },
    },
    {
      path: "/news",
      redirect: "/success-cases",
    },
    {
      path: "/news/detail/:id",
      redirect: (to) => ({
        path: `/success-cases/${to.params.id}`,
      }),
    },
    {
      path: "/contact",
      name: "Contact",
      component: defineAsyncComponent(
        () => import("@/views/contact/index.vue")
      ),
      meta: {
        title: `联系我们｜${COMPANY_NAME}`,
        description:
          "联系郑州云轩网络科技有限公司，咨询软件开发、AI 技术应用和企业数字化服务。",
      },
    },
    {
      path: "/apps/yellow-bird/account-deletion",
      name: "YellowBirdAccountDeletion",
      component: defineAsyncComponent(
        () => import("@/views/apps/yellow-bird/account-deletion.vue")
      ),
      meta: {
        title: `黄鸟人际账号与数据删除｜${COMPANY_NAME}`,
        description:
          "申请删除 Yellow Bird Relationships（黄鸟人际）账号及关联数据，了解身份核验、处理范围和保存例外。",
      },
    },
    {
      path: "/:pathMatch(.*)*",
      name: "NotFound",
      component: defineAsyncComponent(
        () => import("@/views/not-found/index.vue")
      ),
      meta: {
        title: `页面未找到｜${COMPANY_NAME}`,
        description: "您访问的页面不存在或已被移动。",
        noindex: true,
      },
    },
  ],
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

router.afterEach((to) => {
  updateDocumentSeo(to);
});

export default router;
